import { render, staticRenderFns } from "./ModalSelecionarTerritoriosBaseVegaSobrepostosPY.vue?vue&type=template&id=4078e41d&scoped=true&lang=pug"
import script from "./ModalSelecionarTerritoriosBaseVegaSobrepostosPY.vue?vue&type=script&lang=js"
export * from "./ModalSelecionarTerritoriosBaseVegaSobrepostosPY.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecionarTerritoriosBaseVegaSobrepostosPY.vue?vue&type=style&index=0&id=4078e41d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4078e41d",
  null
  
)

export default component.exports